import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 64px;
  row-gap: 24px;
`
